
<template>
    <van-field class="custom-field" v-model="dataValue" :type="openEye?'text':'password'" :placeholder="placeholder" maxlength="20" clearable>
    <template #button>
      <van-icon v-if="!openEye && dataValue" name="closed-eye" size="18" color="#9A9A9A" @click="openEye=true" />
      <van-icon v-if="openEye && dataValue" name="eye-o" size="18" color="#9A9A9A" @click="openEye=false" />
    </template>
  </van-field>
  </template>
<script>

export default {
  name: 'PwdInputView',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dataValue: this.value,
      openEye: false
    }
  },
  watch: {
    value: function(newValue, oldValue) {
      this.dataValue = newValue
    },
    dataValue: function(newValue, oldValue) {
      this.$emit('change', newValue)
    }
  },
  methods: {

  }
}
</script>
  <style lang="less" scoped>
    .custom-field {
      background-color: #F5F7FA;
      margin-top: 16px;
      border-radius: 8px;
      font-size: 14px;
    }
    .custom-field /deep/ .van-field__control {
      border-bottom: none;
      height: 40px;
    }
    .custom-field /deep/ .van-field__button {
      display: flex;
      align-items: center;
    }
  </style>
